<script context="module" lang="ts">
    export function roundedIcon(country: string): string {
        return `/next-static/images/circle-flags/flags/${country.toLowerCase()}.svg`;
    }
</script>

<script lang="ts">
    import { getContainer } from '$components/Context/ContainerContext.js';
    import Picture from './Picture.svelte';
    import { match } from 'ts-pattern';

    export let country: string;
    export let size: '16' | '24' | '32' | '48' | '64' | '64h' | 'hd' = '48';
    export let style: 'shiny' | 'flat' | 'rounded' = 'flat' as const;
    export let title: string | null = null;
    export let pictureClass: string | null = null;
    let className: string | null = null;
    export { className as class };

    $: webp = match(style)
        .with(
            'shiny',
            'flat',
            () =>
                `/next-static/images/flags/${style}/${size}/${country.toLowerCase()}.webp`,
        )
        .with('rounded', () => null)
        .exhaustive();

    $: png = match(style)
        .with(
            'shiny',
            'flat',
            () =>
                `/next-static/images/flags/${style}/${size}/${country.toLowerCase()}.png`,
        )
        .with('rounded', () => null)
        .exhaustive();

    $: svg = match(style)
        .with('shiny', 'flat', () => null)
        .with('rounded', () => roundedIcon(country))
        .exhaustive();

    const { intl } = getContainer();
</script>

<Picture
    {pictureClass}
    class={className}
    {webp}
    {png}
    {svg}
    {title}
    alt="Drapeau {intl().countryLabel(country)}"
/>
